import EventBus from "../event-bus";

export default {
  data() {
    return {
      showColorPickerCanva: false,
      loading: false,
      uniqueId: new Date(),
      hovering: false,
      colorPreviewColor: "",
    };
  },

  props: {},

  computed: {
    isColorPickerActive() {
      let isActive;
      if (this.isInteractionsEntity) {
        isActive =
          this.$store.state.interactions.colorPicker.active &&
          this.$store.state.interactions.colorPicker.interactionId ===
            this.dataInteraction.id;
      } else {
        isActive = this.$store.state.captiveStyle.colorPicker.active;
      }
      return isActive;
    },
    myUniqueId() {
      return `colorPreview-${this.uniqueId}`;
    },
    isInteractionsEntity() {
      return this.entity === "interactions";
    },
  },

  watch: {
    isColorPickerActive(val) {
      if (val) {
        this.mountCanvas();
      } else {
        window.removeEventListener("mousemove", this.setColorPreviewPosition);
        this.showColorPickerCanva = false;
      }
    },
  },

  methods: {
    mountCanvas() {
      this.loading = true;
      const image = new Image();
      image.crossOrigin = "Anonymous";
      image.src = this.isInteractionsEntity ? this.interaction.mediaMobile : `${process.env.VUE_APP_BACK_END_URL}/file/public/background/${this.config.registerBackground}`;

      const componentRef = this.isInteractionsEntity
        ? "interaction"
        : "captiveScreen";

      image.onload = () => {
        const context = this.$refs.canvas.getContext("2d");

        this.$refs.canvas.width = this.$refs[componentRef].clientWidth;
        this.$refs.canvas.height = this.$refs[componentRef].clientHeight;

        this.drawImageProp(
          context,
          image,
          0,
          0,
          this.$refs[componentRef].clientWidth,
          this.$refs[componentRef].clientHeight
        );

        this.loading = false;
      };

      const mutation = this.isInteractionsEntity
        ? "SET_COLOR_PICKER_STATE_INTERACTION"
        : "SET_COLOR_PICKER_STATE_CAPTIVE_STYLE";

      image.onerror = () => {
        this.$store.commit(mutation, {
          active: false,
        });

        EventBus.$emit("show-message", {
          type: "ERROR",
          message: this.$t("message.errorMessages.message.loadImage"),
        });

        this.loading = false;
      };
    },
    drawImageProp(ctx, img, x, y, w, h, offsetX, offsetY) {
      if (arguments.length === 2) {
        x = y = 0;
        w = ctx.canvas.width;
        h = ctx.canvas.height;
      }

      // default offset is center
      offsetX = typeof offsetX === "number" ? offsetX : 0.5;
      offsetY = typeof offsetY === "number" ? offsetY : 0.5;

      // keep bounds [0.0, 1.0]
      if (offsetX < 0) offsetX = 0;
      if (offsetY < 0) offsetY = 0;
      if (offsetX > 1) offsetX = 1;
      if (offsetY > 1) offsetY = 1;

      var iw = img.width,
        ih = img.height,
        r = Math.min(w / iw, h / ih),
        nw = iw * r, // new prop. width
        nh = ih * r, // new prop. height
        cx,
        cy,
        cw,
        ch,
        ar = 1;

      // decide which gap to fill
      if (nw < w) ar = w / nw;
      if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh; // updated
      nw *= ar;
      nh *= ar;

      // calc source rectangle
      cw = iw / (nw / w);
      ch = ih / (nh / h);

      cx = (iw - cw) * offsetX;
      cy = (ih - ch) * offsetY;

      // make sure source rectangle is valid
      if (cx < 0) cx = 0;
      if (cy < 0) cy = 0;
      if (cw > iw) cw = iw;
      if (ch > ih) ch = ih;

      // fill image in dest. rectangle
      ctx.drawImage(img, cx, cy, cw, ch, x, y, w, h);
      this.showColorPickerCanva = true;
    },
    startColorPreview() {
      window.addEventListener("mousemove", this.setColorPreviewPosition);
    },
    setHover() {
      if (this.isColorPickerActive) {
        this.startColorPreview();
        this.hovering = true;
      }
    },
    unsetHover() {
      this.hovering = false;
      window.removeEventListener("mousemove", this.setColorPreviewPosition);
    },
    getColor() {
      const context = this.$refs.canvas.getContext("2d");

      const xPos = event.offsetX;
      const yPos = event.offsetY;

      const color = context.getImageData(xPos, yPos, 1, 1).data;

      this.colorPreviewColor = `rgba(${color[0]}, ${color[1]}, ${color[2]}, ${color[3]})`;
    },
    setColor(evt) {
      const context = this.$refs.canvas.getContext("2d");

      const xPos = event.offsetX;
      const yPos = event.offsetY;

      const color = context.getImageData(xPos, yPos, 1, 1).data;

      const mutation = this.isInteractionsEntity
        ? "SET_COLOR_PICKER_VAL_INTERACTION"
        : "SET_COLOR_PICKER_VAL_CAPTIVE_STYLE";

      this.$store.commit(mutation, {
        r: color[0],
        g: color[1],
        b: color[2],
        a: color[3],
      });

      evt.stopPropagation();
    },
    setColorPreviewPosition(event) {
      const _el = this.$refs[this.myUniqueId];
      _el.style.top = event.clientY - 10 + "px";
      _el.style.left = event.clientX + 20 + "px";
    },
  },

  beforeDestroy() {
    window.removeEventListener("mousemove", this.setColorPreviewPosition);
  },
};
